import React from 'react';
import { HelpCircle, Users, Bell, Play } from 'lucide-react';

const HelpPage = () => (
  <div className="space-y-6">
    <h2 className="text-2xl font-bold text-gray-900">Help</h2>
    
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="bg-white p-6 rounded-lg shadow border">
        <h3 className="text-lg font-semibold mb-4">Documentation</h3>
        <div className="space-y-3">
          <button type="button" className="block w-full text-left p-3 border rounded-lg hover:bg-gray-50 transition-colors">
            <h4 className="font-medium">Getting Started Guide</h4>
            <p className="text-sm text-gray-600">Learn the platform basics</p>
          </button>
          <button type="button" className="block w-full text-left p-3 border rounded-lg hover:bg-gray-50 transition-colors">
            <h4 className="font-medium">API Documentation</h4>
            <p className="text-sm text-gray-600">Complete REST API reference</p>
          </button>
          <button type="button" className="block w-full text-left p-3 border rounded-lg hover:bg-gray-50 transition-colors">
            <h4 className="font-medium">Interruptible/Community Concepts</h4>
            <p className="text-sm text-gray-600">Understand different compute types</p>
          </button>
        </div>
      </div>

      <div className="bg-white p-6 rounded-lg shadow border">
        <h3 className="text-lg font-semibold mb-4">Video Tutorials</h3>
        <div className="space-y-3">
          <div className="p-3 border rounded-lg hover:bg-gray-50 transition-colors cursor-pointer">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-gray-200 rounded-lg flex items-center justify-center">
                <Play size={20} className="text-gray-600" />
              </div>
              <div>
                <h4 className="font-medium">Creating a Cluster</h4>
                <p className="text-sm text-gray-600">5:30 min</p>
              </div>
            </div>
          </div>
          <div className="p-3 border rounded-lg hover:bg-gray-50 transition-colors cursor-pointer">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-gray-200 rounded-lg flex items-center justify-center">
                <Play size={20} className="text-gray-600" />
              </div>
              <div>
                <h4 className="font-medium">Docker Image Upload</h4>
                <p className="text-sm text-gray-600">3:45 min</p>
              </div>
            </div>
          </div>
          <div className="p-3 border rounded-lg hover:bg-gray-50 transition-colors cursor-pointer">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-gray-200 rounded-lg flex items-center justify-center">
                <Play size={20} className="text-gray-600" />
              </div>
              <div>
                <h4 className="font-medium">COG Configuration</h4>
                <p className="text-sm text-gray-600">7:20 min</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="bg-white p-6 rounded-lg shadow border">
      <h3 className="text-lg font-semibold mb-4">Support</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="text-center p-4 border rounded-lg">
          <HelpCircle size={32} className="mx-auto text-purple-600 mb-2" />
          <h4 className="font-medium mb-1">Documentation</h4>
          <p className="text-sm text-gray-600">Complete guides and references</p>
        </div>
        <div className="text-center p-4 border rounded-lg">
          <Users size={32} className="mx-auto text-purple-600 mb-2" />
          <h4 className="font-medium mb-1">Community</h4>
          <p className="text-sm text-gray-600">Community forum</p>
        </div>
        <div className="text-center p-4 border rounded-lg">
          <Bell size={32} className="mx-auto text-purple-600 mb-2" />
          <h4 className="font-medium mb-1">Support</h4>
          <p className="text-sm text-gray-600">Contact our team</p>
        </div>
      </div>
    </div>
  </div>
);

export default HelpPage;